import { getRequest, postPutRequest } from '..';
import environment from 'environment';
import { addShopNameToOrder, combineShopifyOrderByDate } from 'util/shopifyUtil';
import makeCloudFunctionRequest from 'api/makeCloudFunctionRequest';

const { SHOPIFY_BASE_URL } = environment.eCommerce;

export const shopifyGetQuery = getRequest(SHOPIFY_BASE_URL);
export const shopifyPostPutQuery = postPutRequest(SHOPIFY_BASE_URL);

export const shopifyGetMultiQuery = async ({ api, queries }) => {
  const requests = queries.map(async (query) => {
    const orders = await shopifyGetQuery(api, query);
    if (query.shop) {
      return addShopNameToOrder(orders, query.shop);
    }

    return orders;
  });

  const responses = await Promise.all(requests);

  return combineShopifyOrderByDate(responses);
};

export const getShopifyConfigs = (simplrAccountId) => {
  const params = {
    simplrAccountId: simplrAccountId,
  };

  return makeCloudFunctionRequest('getShopifySimplrConfigs', params);
};

export const updateOrderAddress = (params) => {
  const orderId = params.orderId;

  return shopifyPostPutQuery('patch', `/order/${orderId}/address`, params);
};

/**
 * Perform a refund amount
 * @param {object} options
 * @param {string} options.orderId
 * @param {?string} options.comment
 * @param {string} options.shopName
 * @return {Function}
 */
export const shopifyRefundAmount = (options) => {
  const { orderId, comment = null, amount = 0, conversationId, addNotes, shopName } = options;

  const payload = {
    orderId,
    comment,
    amount,
    shopName,
  };

  if (conversationId && addNotes) {
    payload.conversationId = conversationId;
    payload.addNotes = addNotes;
  }

  return shopifyPostPutQuery('post', '/refundAmount', payload);
};

export const patchOrderTags = async ({ simplrAccountId, orderId, shopName, tags }) => {
  const payload = {
    simplrAccountId,
    orderId: orderId.toString(),
    shopName,
    tags,
  };

  return shopifyPostPutQuery('patch', '/order/tags', payload);
};
